import { render, staticRenderFns } from "./LastVisit.vue?vue&type=template&id=322efe29&scoped=true&"
import script from "./LastVisit.vue?vue&type=script&lang=js&"
export * from "./LastVisit.vue?vue&type=script&lang=js&"
import style0 from "./LastVisit.vue?vue&type=style&index=0&id=322efe29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322efe29",
  null
  
)

export default component.exports